module.exports = {
          srcSet: __webpack_public_path__ + "bb6e2d983e4c38b8536906bd0972cf3d-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "bb6e2d983e4c38b8536906bd0972cf3d-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "bb6e2d983e4c38b8536906bd0972cf3d-120.png",
          toString:function(){return __webpack_public_path__ + "bb6e2d983e4c38b8536906bd0972cf3d-120.png"},
          
          width: 120,
          height: 120
        }